<div class="row w-100 pt-3 row-title">
    <div class="bold-text blue-color text-center w-100 pb-3 proc-title">Annuler changement de réseau</div>
    <div class="col-12 w-100">
        <div class="w-100 pt-3">
            Je souhaite annuler le changement de réseau prévu le <strong>{{ portabilityDate }}</strong>.
            <div class="w-100 pt-3 text-center cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
            </div>
        </div>
    </div>
</div>
